import React from "react";

// Minimal institutional mark — two arcs converging into a center point.
// No gradients. No emoji. Mono wordmark with serif lift on the lowercase "e".
export default function Logo({ className = "", showWordmark = true, tone = "ink" }) {
  const stroke = tone === "sand" ? "#EDE6D8" : "#15201C";
  const accent = "#C2542A";
  const text = tone === "sand" ? "text-sand" : "text-ink";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="esulah-logo">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {/* left arc */}
        <path d="M5 6 C 11 12, 14 16, 17 17" stroke={stroke} strokeWidth="1.5" fill="none" strokeLinecap="round" />
        {/* right arc */}
        <path d="M29 6 C 23 12, 20 16, 17 17" stroke={stroke} strokeWidth="1.5" fill="none" strokeLinecap="round" />
        {/* baseline */}
        <line x1="5" y1="27" x2="29" y2="27" stroke={stroke} strokeWidth="1" />
        {/* meeting point */}
        <circle cx="17" cy="17" r="2.2" fill={accent} />
      </svg>
      {showWordmark && (
        <div className={`leading-none ${text}`}>
          <div className="font-display text-[22px] tracking-tight" style={{ fontWeight: 500 }}>
            <span style={{ fontStyle: "italic" }}>e</span>Sulah
          </div>
        </div>
      )}
    </div>
  );
}
